// src/components/Login/LoginStyles.js
import { makeStyles } from '@mui/styles';
import { mix_hexes } from '../../lib/helpers/colorHelpers';

const getTheme = (props, theme) => (props && props.theme ? props.theme : theme);

export const useLoginStyles = makeStyles((theme) => ({
  root: (props) => ({
    display: 'flex',
  }),
  bgshape1: (props) => {
    const appliedTheme = getTheme(props, theme);
    return {
      position: 'fixed',
      left: 0,
      top: 0,
      width: '100%',
      height: '100vh',
      zIndex: -1,
      backgroundColor: appliedTheme.palette.primary.main,
    };
  },
  bgshape2: (props) => {
    const appliedTheme = getTheme(props, theme);
    const primaryMain = appliedTheme.palette.primary.main;
    const secondaryMain = appliedTheme.palette.secondary.main;
    const tertiaryMain = appliedTheme.palette.tertiary.main;
    return {
      transform: 'rotate(' + Math.floor(Math.random() * 45 + 10) + 'deg)',
      position: 'fixed',
      right: -500,
      top: -100,
      width: 0,
      height: 0,
      borderTop: '100vh solid transparent',
      borderBottom: '100vh solid transparent',
      borderLeft:
        '100vh solid ' + tertiaryMain ??
        (primaryMain && secondaryMain ? mix_hexes(primaryMain, secondaryMain) : '#b6b6b6'),
      zIndex: -1,
      backgroundColor: tertiaryMain
        ? tertiaryMain
        : primaryMain && secondaryMain
        ? mix_hexes(primaryMain, secondaryMain)
        : '#b6b6b6',
    };
  },
  bgshape3: (props) => {
    const appliedTheme = getTheme(props, theme);
    return {
      transform: 'rotate(' + Math.floor(Math.random() * 40 + 1) + 'deg)',
      position: 'fixed',
      left: '-50vh',
      top: '-55vh',
      width: 0,
      height: 0,
      borderTop: '100vh solid transparent',
      borderBottom: '100vh solid transparent',
      borderLeft: '100vh solid ' + appliedTheme.palette.secondary.main,
      zIndex: -1,
      backgroundColor: appliedTheme.palette.secondary.main,
    };
  },
  paper: (props) => ({
    minWidth: 400,
    width: '80vw',
    minHeight: '65vh',
    maxWidth: 1000,
    paddingBottom: 15,
    margin: '15vh auto 5vh',
    backgroundColor: theme.palette.common.white,
    borderRadius: 8,
    [theme.breakpoints.down('lg')]: {
      margin: '5vh auto 5vh',
      minHeight: '80vh',
    },
    [theme.breakpoints.down('md')]: {
      margin: '5vh auto 5vh',
      minHeight: '90vh',
      width: '90vw',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 600,
    },
  }),
  container: (props) => ({
    width: '100%',
    minWidth: 300,
    margin: 'auto',
    display: 'block',
    overflowY: 'auto',
  }),
  welcomeMessage: (props) => ({
    marginTop: 0,
    fontSize: '1.4rem',
    margin: 'auto',
    marginBottom: 15,
    textAlign: 'center',
    maxWidth: '60%',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '75%',
      fontSize: '1.3rem',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '90%',
      fontSize: '1.1rem',
    },
    '& img': {
      maxHeight: 200,
      margin: '10px auto 0',
    },
  }),
}));
